import { defineComponent } from 'vue';
import { IonItem, IonLabel, IonIcon } from '@ionic/vue';
import { close, checkmark } from 'ionicons/icons';
export default defineComponent({
    setup() {
        return {
            close, checkmark
        };
    },
    components: {
        IonItem,
        IonLabel,
        IonIcon
    }
});
